import React from "react";
import { GalleryHeader } from "./styles";

const GalleryHeading = () => {
  return (
    <GalleryHeader>
      <h1>gallery</h1>
      <h3>a collection of previous work</h3>
    </GalleryHeader>
  );
};

export default GalleryHeading;
